var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo } from 'react';
export const useFieldDependency = ({ dependencyValue, disabled, label, required, }) => {
    _react_refresh_temp_1();
    const isBuiltDisabled = useMemo(() => Boolean(typeof disabled === 'function'
        ? disabled(dependencyValue)
        : disabled), [dependencyValue, disabled]);
    const builtLabel = useMemo(() => typeof label === 'function' ? label(dependencyValue) : label || '', [dependencyValue, label]);
    const isBuiltRequired = useMemo(() => Boolean(typeof required === 'function'
        ? required(dependencyValue)
        : required), [dependencyValue, required]);
    return {
        disabled: isBuiltDisabled,
        label: builtLabel,
        required: isBuiltRequired,
    };
};
_react_refresh_temp_1(useFieldDependency, "2zsg22G9KA1wf21UeRJZInz/Giw=");
